<template>
  <div class="clinicReseterWrapper">
    <!-- <v-icon v-if="!isReseting" size="25" @click="_reset">
      mdi-refresh
    </v-icon> -->
    <button class="resetBtn" v-if="!isReseting" @click="_reset">
        Reset
    </button>
    <div v-if="isReseting" class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <v-snackbar v-model="snackbar">
      {{ notification }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../api-calls";

export default {
  name: "ClinicReseter",
  components: {},
  props: {
    clinic: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isReseting: false,
    notification: "",
    snackbar: false
  }),
  methods: {
    async _reset() {
      this.isReseting = true;
      try {
        await ApiCalls.resetClinic(this.clinic.practice_ID);
        this.notification = `${this.clinic.company} data reset successfully`;
      } catch (error) {
        this.notification = "Failed to reset clinic data";
      }
      this.isReseting = false;
      this.snackbar = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.clinicReseterWrapper {
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 22px;
    height: 22px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    margin: 3px;
    border: 3px solid #00a75c;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #00a75c transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .resetBtn {
    padding: 3px 12px;
    background: #00a75c;
    color: white;
    border-radius: 4px;
  }
}
</style>
